<app-card-v2 [title]="title"
             [displayRefreshButton]="true"
             (refreshEvent)="service.refresh()">
    <app-button header-actions iconName="edit" (clickEvent)="editMultiple()" tooltip="Modifier plusieurs prix"></app-button>
    <app-button header-actions iconName="plus" (clickEvent)="addProduct()" tooltip="Ajouter un produit" *ngIf="sale"></app-button>
    <app-datatable-data *ngIf="saleId"
                        [paginatedService]="service"
                        [parameters]="urlParameters"
                        noResultLabel="Aucun produit"
                        pageSize="20">
        <ng-container thead>
            <th>Produit</th>
            <th>Quantité</th>
            <th>Taux de TVA</th>
            <th>PU HTVA</th>
            <th>PU TTC</th>
            <th>Total TTC</th>
            <th>Actions</th>
        </ng-container>

        <ng-template let-product='element' template-content>
            <app-sale-product-card-row
                    (productDeletedEvent)="productDeleted($event)"
                    (priceUpdatedEvent)="refresh()"
                    [entity]="product"
                    [saleId]="saleId"></app-sale-product-card-row>
        </ng-template>

        <ng-container tfoot>
            <th>Produit</th>
            <th>Quantité</th>
            <th>Taux de TVA</th>
            <th>PU HTVA</th>
            <th>PU TTC</th>
            <th>Total TTC</th>
            <th>Actions</th>
        </ng-container>
    </app-datatable-data>
    <app-view-by-id-default [findByIdService]="saleService" [id]="saleId" (entityLoaded)="saleLoaded($event)">
        <ng-container *ngIf="sale">
            <div class="text-right">
                <br/>
                Montant total:
                <app-price-label [price]="sale.summary.totalPriceVatIncluded"></app-price-label>
            </div>
        </ng-container>
    </app-view-by-id-default>
</app-card-v2>